export default "__VITE_ASSET__9577ae5c__"